// extracted by mini-css-extract-plugin
export var actionsRow = "_1j-a";
export var actionsRowEnd = "_1j-b";
export var askRedoBlackBtn = "_1j-d";
export var askRedoBlackBtnIcon = "_1j-e";
export var exitModalActionBtn = "_1j-c";
export var exitModalRoot = "_1j-0";
export var followUpInput = "_1j-9";
export var modalContentBody = "_1j-7";
export var modalHeaderImage = "_1j-2";
export var modalImageLabel = "_1j-4";
export var modalImageOverlay = "_1j-3";
export var modalImageSubheading = "_1j-6";
export var modalImageTitle = "_1j-5";
export var modalImageWrapper = "_1j-1";
export var reasonCard = "_1j-f";
export var reasonCardSelected = "_1j-g";
export var reasonIcon = "_1j-j";
export var reasonIconWrap = "_1j-i";
export var reasonIndicator = "_1j-l";
export var reasonIndicatorDot = "_1j-n";
export var reasonIndicatorSelected = "_1j-m";
export var reasonLabel = "_1j-h";
export var reasonList = "_1j-8";
export var reasonTitle = "_1j-k";